import { render, staticRenderFns } from "./CMSPageDetails.vue?vue&type=template&id=9f1bd470&"
import script from "./CMSPageDetails.vue?vue&type=script&lang=js&"
export * from "./CMSPageDetails.vue?vue&type=script&lang=js&"
import style0 from "./CMSPageDetails.vue?vue&type=style&index=0&id=9f1bd470&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports